import React from "react"
import styled from "@emotion/styled"
import { Checkbox, FormControlLabel } from "@material-ui/core"

type Props = {
  assessorName: string
  onChange: (value: boolean) => any
  value?: boolean
  hasError?: boolean
}

const IdentityContainer = styled.div({
  paddingTop: "20px",
  paddingBottom: "20px",
  fontSize: "0.9em"
})

const SdqAssessmentIdentityInput = ({
  assessorName,
  onChange,
  value,
  hasError
}: Props) => {
  const errorActive = !value && hasError
  return (
    <IdentityContainer>
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            style={{ color: errorActive ? "red" : "grey" }}
            onChange={(_event, isInputChecked) => onChange(isInputChecked)}
          />
        }
        label={
          <span style={errorActive ? { color: "red" } : {}}>
            {`I confirm that I am ${assessorName}`}
          </span>
        }
      />
    </IdentityContainer>
  )
}

export default SdqAssessmentIdentityInput
